import React, { useState, useEffect } from "react";
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';

export default function UsersList() {
    const [users, setUsers] = useState([]);
    const { secureFetch } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUsers = async () => {
            const response = await secureFetch('api/auth/users');
            if (response.ok) {
                const data = await response.json();
                setUsers(data);
            }
        };
        fetchUsers();
    }, [secureFetch]);

    const createUser = () => {
        navigate('/admin/users/add');
    };

    const editUser = (userId) => {
        navigate('/admin/users/edit/' + userId);
    };

    const deleteUser = async (selUser) => {
        if (window.confirm(`Are you sure you want to delete the user: ${selUser.username}?`)) {
            const response = await secureFetch(`api/auth/User/delete/${selUser.id}`, {
                method: 'GET'
            });
            if (response.ok) {
                setUsers(users.filter(r => r.id !== selUser.id));
            } else {
                alert("Failed to delete user.");
            }
        }
    };

    return (
        <>
            <div style={{ display: 'flex' }} >
                <h2 style={{ flexGrow: 1 }} >Users List</h2>
                <div>
                    <a class="btn btn-primary" href="javascript:void(0)" onClick={createUser}>
                        Create User
                    </a>
                </div>
            </div>

            {users && users.length > 0 &&
                <table class="table">
                    <thead>
                        <tr>
                            <th>User Name</th>
                            <th>Email</th>
                            {/*<th>Email Confirmed</th>*/}
                            {/*<th>Phone Number</th>*/}
                            {/*<th>Phone Number Confirmed</th>*/}
                            {/*<th>Two Factor Enabled</th>*/}
                            {/*<th>Lockout Enabled</th>*/}
                            {/*<th>Lockout End</th>*/}
                            <th>Created Date</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((item) => (
                            <tr Key={item.id}>
                                <td>{item.username}</td>
                                <td>{item.email}</td>
                                {/*<td>{item.EmailConfirmed ? "Yes" : "No"}</td>*/}
                                {/*<td>{item.PhoneNumber}</td>*/}
                                {/*<td>{item.PhoneNumberConfirmed ? "Yes" : "No"}</td>*/}
                                {/*<td>{item.TwoFactorEnabled ? "Yes" : "No"}</td>*/}
                                {/*<td>{item.LockoutEnabled ? "Yes" : "No"}</td>*/}
                                {/*<td>{item.LockoutEnd.HasValue ? item.LockoutEnd.Value.ToString("HH:mm:ss") : ""}</td>*/}
                                <td>{item.createDate}</td>
                                <td>
                                    <a href="Javascript:void(0);" onClick={() => editUser(item.id)}>Edit</a>
                                    <span className="ms-3">|</span>
                                    <a className="ms-3" href="Javascript:void(0);" onClick={() => deleteUser(item)}>Delete</a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            }
        </>
    );
}